/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAttachment from '../../../../../../Icon/IconAttachment';
import IconCloud from '../../../../../../Icon/IconCloud';
import IconCloudCircle from '../../../../../../Icon/IconCloudCircle';
import IconCloudDone from '../../../../../../Icon/IconCloudDone';
import IconCloudDownload from '../../../../../../Icon/IconCloudDownload';
import IconCloudOff from '../../../../../../Icon/IconCloudOff';
import IconCloudQueue from '../../../../../../Icon/IconCloudQueue';
import IconCloudUpload from '../../../../../../Icon/IconCloudUpload';
import IconCreateNewFolder from '../../../../../../Icon/IconCreateNewFolder';
import IconFileDownload from '../../../../../../Icon/IconFileDownload';
import IconFileUpload from '../../../../../../Icon/IconFileUpload';
import IconFolder from '../../../../../../Icon/IconFolder';
import IconFolderOpen from '../../../../../../Icon/IconFolderOpen';
import IconFolderShared from '../../../../../../Icon/IconFolderShared';

export default function FileIcons() {
  return (
    <div>
      <CategoryHeader>file</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAttachment size="32"/>
          <FigCaption>
            IconAttachment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloud size="32"/>
          <FigCaption>
            IconCloud
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloudCircle size="32"/>
          <FigCaption>
            IconCloudCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloudDone size="32"/>
          <FigCaption>
            IconCloudDone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloudDownload size="32"/>
          <FigCaption>
            IconCloudDownload
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloudOff size="32"/>
          <FigCaption>
            IconCloudOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloudQueue size="32"/>
          <FigCaption>
            IconCloudQueue
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCloudUpload size="32"/>
          <FigCaption>
            IconCloudUpload
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCreateNewFolder size="32"/>
          <FigCaption>
            IconCreateNewFolder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFileDownload size="32"/>
          <FigCaption>
            IconFileDownload
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFileUpload size="32"/>
          <FigCaption>
            IconFileUpload
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFolder size="32"/>
          <FigCaption>
            IconFolder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFolderOpen size="32"/>
          <FigCaption>
            IconFolderOpen
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFolderShared size="32"/>
          <FigCaption>
            IconFolderShared
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/FileIcons.js